import { createRoute, type AnyRoute } from "@tanstack/react-router";
import { BarChart3 } from "lucide-react";

import type { FeatureModule } from "@/features/types";
import { guarded } from "@/lib/auth";

import { KpiDashboardPage } from "./pages/KpiDashboardPage";

/** Search params on /kpi. A KPI tile opens its drill-down drawer in place:
 *  `tile=<key>` → quick view, `+expanded=1` → full-page view. */
export interface KpiSearch {
  tile?: "retention" | "new_business" | "funnel" | "upsell" | "churn" | "booked";
  expanded?: boolean;
  /** Funnel node id when tile=funnel (e.g. "won", "st_churned"). */
  stage?: string;
}

const KPI_TILES = ["retention", "new_business", "funnel", "upsell", "churn", "booked"] as const;

function validateKpiSearch(raw: Record<string, unknown>): KpiSearch {
  const out: KpiSearch = {};
  if (typeof raw.tile === "string" && (KPI_TILES as readonly string[]).includes(raw.tile)) {
    out.tile = raw.tile as KpiSearch["tile"];
  }
  if (raw.expanded === true || raw.expanded === "1" || raw.expanded === "true") {
    out.expanded = true;
  }
  if (typeof raw.stage === "string" && /^[a-z_]{2,32}$/.test(raw.stage)) {
    out.stage = raw.stage;
  }
  return out;
}

export const kpiModule: FeatureModule = {
  key: "kpi",
  nav: {
    label: "KPIs",
    icon: BarChart3,
    to: "/kpi",
    requires: "kpi.read",
    order: 10,
    group: "Overview",
  },
  routes: (rootRoute) => [
    createRoute({
      getParentRoute: () => rootRoute,
      path: "/kpi",
      component: guarded("kpi.read", KpiDashboardPage),
      validateSearch: validateKpiSearch,
    }),
  ] as unknown as AnyRoute[],
};
